<template>
  <el-dialog
    custom-class="myUpLoad"
    title="资源上传"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="600px"
    :before-close="handleClose"
    
  >
    <div class="list_content" v-loading="isDisable" element-loading-text="资源解析中...">
      <uploader
        :options="options" 
        :autoStart="false"
        ref="uploader"
        class="uploader-example"
        @file-added="onFileAdded" 
        @file-success="onFileSuccess"
        @file-progress="onFileProgress"
        @file-error="onFileError"
      >
        <uploader-unsupport></uploader-unsupport> 

        <uploader-list>
          <template slot-scope="props">
            <ul>
              <li v-for="file in props.fileList" :key="file.id" class="liItem">
                <uploader-file :file="file" :list="true" ref="uploaderFile" :pauseFlag="pauseFlag">
                  <template slot-scope="props">
                      <!-- //使用插槽替换组件默认样式 -->
                    <div class="filebox">
                      <p class="fileNameBox">
                        <span class="fileIcon"></span>
                        {{file.name}}
                      </p>
                      <p class="fileProgressBox">
                        <el-progress
                          class="progressLength"
                          :percentage="parseInt((props.progress.toFixed(2))*100-1<0?0:(props.progress.toFixed(2))*100-1)"
                        ></el-progress>
                        <span
                          :class="{statusBtn:!pauseFlag,resumeBtn:pauseFlag}"
                          class="progressBtn"
                          @click="pause(file,file.resourceId)"
                        ></span>
                        <span class="cancelBtn progressBtn" @click="remove(file,file.resourceId)"></span>
                      </p>
                      <p class="fileInfoBox">
                        <span class="fileInfoItem">速度：{{pauseFlag? 0: props.formatedAverageSpeed}}</span>
                        <span
                          class="fileInfoItem"
                        >已上传：{{(parseFloat(props.formatedSize)*props.progress).toFixed(1)}}/{{props.formatedSize}}</span>
                        <span
                          class="fileInfoItem"
                        >剩余时间：{{pauseFlag? 0: props.formatedTimeRemaining}}</span>
                      </p>
                    </div>
                  </template>
                </uploader-file>
              </li>
            </ul>
          </template>
        </uploader-list>
        <!-- //开始上传按钮 -->
        <uploader-btn ref="uploadBtn" id="global-uploader-btn" :attrs="attrs">添加</uploader-btn>
      </uploader>
    </div>
    <div slot="footer" class="dialog-footer upLoadFooter">
      <el-button plain size="medium" @click="cancelAddRes" class="el-button cancel_btn">取 消</el-button>
      <el-button
        :class="{none:isUploading}"
        size="medium"
        @click="continueAddRes"
        class="el-button continueAddRes_btn"
        id="continueAddRes_btn"
      >添加</el-button>
    </div>
  </el-dialog>
</template>
<script>
var resourceId = "";//保存资源id
import SparkMD5 from "spark-md5";

export default {
  data() {
    return {
        dialogVisible:true,
      //上传组件配置
      options: {
        target: UPLOAD,
        testChunks: false, //是否开启服务器分片校验
        maxChunkRetries: 5, //最大自动失败重试上传次数
        chunkSize: 3 * 1024 * 1024,//分片大小
        singleFile: true,//单文件上传
        simultaneousUploads: 1,

        processParams(params) {//每一次分片传给后台的参数，params是该方法返回的形参，包含分片信息
          return {//返回一个对象，会添加到每一个分片的请求参数里面
            name: params.filename,
            code: params.identifier,
            total: params.totalChunks,
            index: params.chunkNumber,
            resourceId,
          };
        }
      },

      attrs: {
        accept: ".zip"
      }
    };
  },

  methods:{
      //文件添加时回调，这里可以做格式校验，md5计算  
    onFileAdded(file) {
      let typeName = file.file.name;
      let reg = /\.zip$/;
      if (!reg.test(typeName)) {
        file.ignored = true;
        this.$alert("上传文件格式不正确，请检查", "上传错误", {
          confirmButtonText: "确定",
          callback: action => {
            
          }
        });
      } else {
          // 计算MD5;
          this.computeMD5(file);
        
      }
    },
    //所有分片上传完成的回调，需要注意的是，由于异步上传，每一次分片上传不会等上一次响应回来才发送，
    //因此该上传成功的回调时，返回的分片响应可能不是最后一片，因此后续会发送合并请求告诉后台进行合并文件
    onFileSuccess(rootFile, file, message, chunk) { 
          //所有分片上传成功，发送合并分片请求，具体参数与后台确定，后台合并文件
    },



    //计算Md5,生成唯一标识uniqueIdentifier
    computeMD5(file) {
      let that = this;
      let fileReader = new FileReader();
      let md5 = "";
      file.pause();//先暂停，后续生成uniqueIdentifier
      fileReader.readAsArrayBuffer(file.file);

      fileReader.onload = e => {
        if (file.size != e.target.result.byteLength) {
          this.error("文件读取失败");
          return;
        }

        md5 = SparkMD5.hash(file.name);//业务需求以文件名作为加密
        file.uniqueIdentifier = md5;

        if (md5 != "") {
          file.resume();//继续上传文件
        }
      };

      fileReader.onerror = function() {
        this.error("文件读取失败");
      };
    },


    //文件上传的过程中会频繁调用该函数
    onFileProgress(rootFile, file, chunk) {},

    //文件上传出错的回调
    onFileError(rootFile, file, msg, chunk) { 
    },






    handleClose(){
        this.dialogVisible = false
    }

  },











  mounted() {
    //组件通信，需要监听开始上传，具体按自己业务决定  
    this.$root.Bus.$on("addResourceUpload", (params) => {
      this.dialogVisible = true;
    
      setTimeout(() => {
        //隐藏原来的上传按钮，模拟点击开始上传  
        document.querySelector("#global-uploader-btn").click();
      }, 50);
    });
  },
  destroyed() {
    this.$root.Bus.$off("addResourceUpload")
  },

}
</script>
